.modal {
  background: var(--static-background-standard);
}

.modalBodyCustom {
  border-radius: 8px 8px 0 0;
}

.modal :global(.modalFooter) {
  border-radius: 0 0 8px 8px;
}

.modalFooterCustom {
  border-radius: 0 0 8px 8px;
}

.billingSummary {
  background: var(--static-background-standard);
  border-radius: 8px;
  border: 1px solid var(--static-divider-standard);
}

.billingInfo {
  background: var(--static-background-standard);
  border-radius: 8px;
  padding: 16px;
  border: 1px solid var(--static-divider-standard);
}

.editButton {
  background: none;
  border: none;
  cursor: pointer;
  font-size: 14px;
  color: var(--color-primary);
  padding: 4px 8px;
  border-radius: 4px;
  transition: background-color 0.2s ease;
}

.editButton:hover {
  background: var(--selectable-hover);
}

.expandButton {
  background: none;
  border: none;
  cursor: pointer;
  color: var(--static-text-standard);
  padding: 4px 8px;
  border-radius: 4px;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
}

.expandButton:hover {
  background: var(--selectable-hover);
}

.row {
  display: flex;
  align-items: center;
  gap: 8px;
}

.value {
  flex: 1;
}

.cardInfo {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  border: 1px solid var(--static-text-inverse-standard);
  border-radius: 8px;
  padding: 0.25rem 0.5rem;
  width: fit-content;
}

.expandedContent {
  padding-top: 16px;
  border-top: 1px solid var(--static-divider-standard);
  margin-top: 8px;
}

.detailRow {
  display: flex;
  align-items: flex-start;
  gap: 8px;
}

.detailLabel {
  font-weight: 500;
  color: var(--static-text-strong);
  min-width: 100px;
}

.detailValue {
  flex: 1;
  color: var(--static-text-standard);
  font-size: var(--fs-small);
}

